import { defineComponent as o, openBlock as n, createBlock as a, unref as p, mergeProps as m, withCtx as c, createElementVNode as s } from "vue";
import { RevIcon as u } from "@ds/components/Icon";
const d = /* @__PURE__ */ o({
  name: "IconBurger",
  __name: "IconBurger",
  props: {
    size: {},
    alternativeText: {}
  },
  setup(r) {
    const t = r;
    return (i, e) => (n(), a(p(u), m(t, { "view-box": "0 0 24 24" }), {
      default: c(() => [...e[0] || (e[0] = [
        s("path", { d: "M2.25 7A.75.75 0 0 1 3 6.25h18a.75.75 0 0 1 0 1.5H3A.75.75 0 0 1 2.25 7m0 10A.75.75 0 0 1 3 16.25h18a.75.75 0 0 1 0 1.5H3A.75.75 0 0 1 2.25 17M3 11.25a.75.75 0 0 0 0 1.5h18a.75.75 0 0 0 0-1.5H3" }, null, -1)
      ])]),
      _: 1
    }, 16));
  }
});
export {
  d as default
};
